<template>
  <div class="content">
    <div class="back" @click="back()">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('resourceAdd.back') }}</span>
    </div>
    <h4>{{ id ? $t('resourceAdd.title.edit') : $t('resourceAdd.title.create') }}</h4>
    <!-- <a-form
      v-if="model === 'admin'"
      :form="form"
      :label-col="{ span: 2 }"
      :wrapper-col="{ span: 10 }"
      @submit="handleSubmit"
    >
      <a-form-item :label="$t('resourceAdd.form.resourceType.label')">
        <a-select
          v-decorator="['type', { initialValue: 'text', rules: [{ required: true, message: $t('resourceAdd.form.resourceType.required') }] }]"
          :placeholder="$t('resourceAdd.form.resourceType.placeholder')"
          @change="value => handleSelectChange(value, true)"
        >
          <a-select-option :value="key" v-for="(item, key) in resTypeMap" :key="key">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :label="resTypeMap[curResType].name + $t('resourceAdd.form.resourceType.label')"
        v-if="curResType === 'image' || curResType === 'video'"
      >
        <a-select
          v-decorator="['subType', { initialValue: 1, rules: [{ required: true, message: $t('resourceAdd.form.resourceType.required') }] }]"
          :placeholder="$t('resourceAdd.form.resourceType.placeholder')"
        >
          <a-select-option :value="1">{{ $t('resourceAdd.form.subType.normal') + resTypeMap[curResType].name }}</a-select-option>
          <a-select-option :value="2">{{ $t('resourceAdd.form.subType.panorama') + resTypeMap[curResType].name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.name.label')">
        <a-input
          :placeholder="$t('resourceAdd.form.name.placeholder')"
          v-decorator="['name', { rules: [{ required: true, message: $t('resourceAdd.form.name.required') }] }]"
        />
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.copyright.label') + ': '">
        <a-select
          v-decorator="['copyrightOwner']"
          :placeholder="$t('resourceAdd.form.copyright.placeholder')"
        >
          <a-select-option :value="1">{{ $t('resourceAdd.form.copyright.school') }}</a-select-option>
          <a-select-option :value="2">{{ $t('resourceAdd.form.copyright.personal') }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.category.label') + ': '">
        <a-select
          v-decorator="['virtualType']"
          :placeholder="$t('resourceAdd.form.category.placeholder')"
        >
          <a-select-option :value="1">{{ $t('resourceAdd.form.category.modular') }}</a-select-option>
          <a-select-option :value="2">{{ $t('resourceAdd.form.category.pureVirtual') }}</a-select-option>
          <a-select-option :value="3">{{ $t('resourceAdd.form.category.mixedReality') }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.intro.label') + ': '">
        <a-textarea
          v-decorator="['intro']"
          :autoSize="{ minRows: 4, maxRows: 8 }"
          :placeholder="$t('resourceAdd.form.intro.placeholder')"
          :maxLength="500"
        />
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.upload.label') ">
        <Upload
          ref="upLoadFile"
          :coverType="resTypeMap[curResType].coverType"
          @uploadData="uploadData"
          @cover="getCover"
          :fileUrl="form.getFieldValue('url')"
          :accept="resTypeMap[curResType].accept"
          :desc="resTypeMap[curResType].desc"
          v-decorator="['url', { rules: [{ required: true, message: $t('resourceAdd.form.upload.required') + resTypeMap[curResType].name }] }]"
        />
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.cover.label')" v-show="curResType === 'model' || curResType === 'software'">
        <Upload
          @uploadData="coverUploadData"
          :fileUrl="form.getFieldValue('cover')"
          :accept="['png', 'jpg']"
          :desc="$t('resourceAdd.form.cover.desc')"
          v-decorator="['cover', {}]"
        />
      </a-form-item>
      <a-form-item :label="$t('resourceAdd.form.size.label')" style="display: none;">
        <a-input
          :placeholder="$t('resourceAdd.form.size.placeholder')"
          v-decorator="['size', { rules: [{ required: true, message: $t('resourceAdd.form.size.required') }] }]"
        />
      </a-form-item>
      <div class="submit">
        <a-button type="primary" html-type="submit">
          {{ $t('resourceAdd.button.submit') }}
        </a-button>
      </div>
    </a-form> -->
    <a-form :form="form" @submit="handleSubmit">
      <div class="flex">
        <a-form-item :label="$t('resourceAdd.form.resourceType.label')">
          <a-select
            v-decorator="['type', { initialValue: 'text', rules: [{ required: true, message: $t('resourceAdd.form.resourceType.required') }] }]"
            :placeholder="$t('resourceAdd.form.resourceType.placeholder')"
            @change="value => handleSelectChange(value, true)"
          >
            <a-select-option :value="key" v-for="(item, key) in resTypeMap" :key="key">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :label="resTypeMap[curResType].name + $t('resourceAdd.form.resourceType.label')"
          v-if="curResType === 'image' || curResType === 'video'"
        >
          <a-select
            v-decorator="['subType', { initialValue: 1, rules: [{ required: true, message: $t('resourceAdd.form.resourceType.required') }] }]"
            :placeholder="$t('resourceAdd.form.resourceType.placeholder')"
          >
            <a-select-option :value="1">{{ $t('resourceAdd.form.subType.normal') + resTypeMap[curResType].name }}</a-select-option>
            <a-select-option :value="2">{{ $t('resourceAdd.form.subType.panorama') + resTypeMap[curResType].name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :label="$t('resourceAdd.form.name.label')">
          <a-input
            :placeholder="$t('resourceAdd.form.name.placeholder')"
            v-decorator="['name', { rules: [{ required: true, message: $t('resourceAdd.form.name.required') }] }]"
          />
        </a-form-item>
        <a-form-item :label="$t('resourceAdd.form.copyright.label') + ': '">
          <a-select
            v-decorator="['copyrightOwner']"
            :placeholder="$t('resourceAdd.form.copyright.placeholder')"
          >
            <a-select-option :value="1">{{ $t('resourceAdd.form.copyright.school') }}</a-select-option>
            <a-select-option :value="2">{{ $t('resourceAdd.form.copyright.personal') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('resourceAdd.form.category.label') + ': '">
          <a-select
            v-decorator="['virtualType']"
            :placeholder="$t('resourceAdd.form.category.placeholder')"
          >
            <a-select-option :value="1">{{ $t('resourceAdd.form.category.modular') }}</a-select-option>
            <a-select-option :value="2">{{ $t('resourceAdd.form.category.pureVirtual') }}</a-select-option>
            <a-select-option :value="3">{{ $t('resourceAdd.form.category.mixedReality') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('resourceAdd.form.intro.label') + ': '">
          <a-textarea
            v-decorator="['intro']"
            :autoSize="{ minRows: 4, maxRows: 8 }"
            :placeholder="$t('resourceAdd.form.intro.placeholder')"
            :maxLength="500"
          />
        </a-form-item>
        <a-form-item :label="$t('resourceAdd.form.upload.label') ">
          <Upload
            ref="upLoadFile"
            :coverType="resTypeMap[curResType].coverType"
            @uploadData="uploadData"
            @cover="getCover"
            :fileUrl="form.getFieldValue('url')"
            :accept="resTypeMap[curResType].accept"
            :desc="resTypeMap[curResType].desc"
            v-decorator="['url', { rules: [{ required: true, message: $t('resourceAdd.form.upload.required') + resTypeMap[curResType].name }] }]"
          />
        </a-form-item>

        <a-form-item :label="$t('resourceAdd.form.cover.label')" v-show="curResType === 'model' || curResType === 'software'">
          <Upload
            @uploadData="coverUploadData"
            :fileUrl="form.getFieldValue('cover')"
            :accept="['png', 'jpg']"
            :desc="$t('resourceAdd.form.cover.desc')"
            v-decorator="['cover', {}]"
          />
        </a-form-item>

        <a-form-item :label="$t('resourceAdd.form.size.label')" style="display: none;">
          <a-input
            :placeholder="$t('resourceAdd.form.size.placeholder')"
            v-decorator="['size', { rules: [{ required: true, message: $t('resourceAdd.form.size.required') }] }]"
          />
        </a-form-item>
      </div>

      <div class="submit">
        <a-button type="primary" html-type="submit">
          {{ $t('resourceAdd.button.submit') }}
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'
import { batchUpload, getPersonResDetails } from '@/api/lesson'

export default {
  name: 'PtAdd',
  components: {
    Upload
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'resourceAdd' }),
      resTypeMap: {
        text: {
          name: this.$t('resourceAdd.resourceTypes.text.name'),
          accept: ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'ppt', 'pptx'],
          desc: this.$t('resourceAdd.resourceTypes.text.desc'),
          coverType: 'word'
        },
        image: {
          name: this.$t('resourceAdd.resourceTypes.image.name'),
          accept: ['gif', 'jpeg', 'jpg', 'png'],
          desc: this.$t('resourceAdd.resourceTypes.image.desc'),
          coverType: 'image'
        },
        audio: {
          name: this.$t('resourceAdd.resourceTypes.audio.name'),
          accept: ['mp3', 'wav'],
          desc: this.$t('resourceAdd.resourceTypes.audio.desc'),
          coverType: 'audio'
        },
        video: {
          name: this.$t('resourceAdd.resourceTypes.video.name'),
          accept: ['mp4'],
          desc: this.$t('resourceAdd.resourceTypes.video.desc'),
          coverType: 'video'
        },
        model: {
          name: this.$t('resourceAdd.resourceTypes.model.name'),
          accept: ['fbx', 'glb'],
          desc: this.$t('resourceAdd.resourceTypes.model.desc'),
          coverType: 'model'
        },
        software: {
          name: this.$t('resourceAdd.resourceTypes.software.name'),
          accept: ['zip', 'exe'],
          desc: this.$t('resourceAdd.resourceTypes.software.desc'),
          coverType: 'software'
        }
      },
      curResType: 'text',
      coverUrl: '',
      id: '',
      model: ''
    }
  },

  mounted() {
    const id = this.$route.query.id
    this.model = this.$route.query.model
    this.id = id
    if (id) {
      getPersonResDetails({ id: id }).then(res => {
        console.log('res ----->', res)
        if (res.code !== 200) return
        const data = res.data
        this.handleSelectChange(data.type)
        this.$nextTick(() => {
          this.form.setFieldsValue({
            name: data.name,
            url: data.files[0].url,
            size: data.files[0].size,
            cover: data.cover,
            subType: data.subType,
            type: data.type,
            version: data.files[0].version,
            copyrightOwner: data.copyrightOwner || undefined,
            virtualType: data.virtualType || undefined,
            intro: data.intro
          })
        })
        if (data.type === 'video') {
          this.coverUrl = data.cover
        }
        this.$forceUpdate()
      })
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    },
    uploadData(data) {
      if (!data.length) return
      const file = data[0]
      console.log('file ----->', file)
      function getFileExtension(filename) {
        const match = filename.match(/^(.*?)(\.[^.]+)?$/)
        return match ? match[1] : null
      }
      this.form.setFieldsValue({
        name: getFileExtension(file.name),
        url: file.url,
        size: file.originalSize
      })
    },
    coverUploadData(data) {
      const file = data[0]
      console.log('file ----->', file)
      this.form.setFieldsValue({
        cover: file.url
      })
    },
    getCover(file) {
      this.coverUrl = file.url
    },
    handleSelectChange(data, isReset = false) {
      this.curResType = data
      if (!isReset) return
      this.form.setFieldsValue({
        name: '',
        url: '',
        size: '',
        cover: '',
        type: '',
        version: '',
        copyrightOwner: undefined,
        virtualType: undefined,
        intro: ''
      })
      this.$refs.upLoadFile.deleteFile()
    },
    handleSubmit(e) {
      e.preventDefault()
      function getFileExtension(filename) {
        // 使用正则表达式匹配最后一个点后面的部分
        const match = filename.match(/\.([^.]+)$/)
        return match ? match[1].toLowerCase() : null
      }
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          if (values.type === 'image') {
            values.cover = values.url
          }
          if (values.type === 'video') {
            values.cover = this.coverUrl
          }
          if (this.id) {
            values.id = this.id
          }
          values.intro = values.intro || ''
          values.version = 1
          values.fileType = getFileExtension(values.url).includes('zip') ? 'exe' : getFileExtension(values.url)
          console.log('values ----->', values)
          batchUpload({ list: [values] }).then(res => {
            this.$message.success(this.$t('resourceAdd.message.success', { 
              action: this.id ? this.$t('resourceAdd.message.action.edit') : this.$t('resourceAdd.message.action.create')
            }))
            this.back()
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0px 20px;
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    /deep/ .ant-form-item {
      width: 46%;
    }
  }
  h4 {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: dashed 1px #d6d6d6;
    margin-bottom: 20px;
  }
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 16px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    margin-top: 22px;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .upload {
    border-radius: 10px;
    border: solid 1px #d6d6d6;
    background: #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 300px;
    height: 150px;
  }
  .upload-file {
    height: 160px !important;
    width: 300px !important;
    background: #fcfcfc;
    /deep/ .ant-btn {
      background: #fcfcfc;
    }
  }
  /deep/ .ant-form-item-label {
    margin-right: 10px;
  }
  .submit {
    margin-top: 100px;
    display: flex;
    justify-content: center;
  }
}
</style>
